<kt-base-modal [title]="taskName || 'Comments'">
  <div modal-body class="p-0">
    <kt-loader [showLoader]="loading()">

      <div class="tc-feed px-4 pt-3">
        @if (noAccess()) {
          <kt-no-record-found [noRecordFound]="noAccessRecord"></kt-no-record-found>
        } @else if (!comments().length) {
          <kt-no-record-found [noRecordFound]="noComments"></kt-no-record-found>
        }

        @for (comment of comments(); track comment.advance_task_comment_id) {
          <div class="tc-item">
            <div class="tc-item__head">
              <span class="tc-item__author">{{ authorLabel(comment) }}</span>
              <span class="tc-item__time">{{ timeLabel(comment) }}</span>

              @if (isMine(comment) && !readOnly) {
                <button type="button" class="tc-item__delete" (click)="deleteComment(comment)"
                  ngbTooltip="Delete" triggers="hover" container="body">
                  <svg-icon class="svg_icon13x13 d-inline"
                    src="assets/media/iq-svg/without_circle/icon_set_3/delete.svg"></svg-icon>
                </button>
              }
            </div>

            @if (comment.advance_task_comment_text) {
              <p class="tc-item__text">{{ comment.advance_task_comment_text }}</p>
            }

            @if (comment.advance_task_comment_scan_image_url; as photo) {
              <button type="button" class="tc-item__photo" aria-label="View photo" (click)="openPhoto(photo)">
                <img [src]="photo" alt="Attached photo" />
              </button>
            }
          </div>
        }
      </div>

      @if (readOnly && readOnlyReason) {
        <div class="tc-readonly">
          <div class="alert alert-warning">
            <i class="la la-info-circle"></i>
            <span>{{ readOnlyReason }}</span>
          </div>
        </div>
      }

      @if (!readOnly) {
        <div class="tc-compose px-4 py-3">
          <kt-textarea [field]="commentField" [form]="form" [options]="{}" />

          @if (imageUrl()) {
            <div class="tc-compose__file">
              <span class="tc-compose__file-name">{{ imageName() }}</span>
              <button type="button" class="tc-compose__file-remove" (click)="removeImage()">Remove</button>
            </div>
          }

          <div class="tc-compose__actions">
            <label class="btn btn-sm btn-label-brand tc-compose__attach" [class.disabled]="uploading()">
              {{ uploading() ? 'Uploading…' : 'Attach photo' }}
              <input type="file" accept="image/*" hidden [disabled]="uploading()" (change)="fileChange($event)" />
            </label>

            <button type="button" class="btn btn-sm btn-brand"
              [disabled]="!canPost() || saving() || uploading()" (click)="post()">Submit</button>
          </div>
        </div>
      }
    </kt-loader>
  </div>
</kt-base-modal>
